import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: 'ホーム', href: '/' },
    { name: 'プロフィール', href: '/profile-detail' },
    { name: '活動報告', href: '/activities-detail' },
    { name: 'お問い合わせ', href: '/contact-detail' },
  ];

  const navigateToHash = (hashHref: string) => {
    const doScroll = () => {
      const element = document.querySelector(hashHref);
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(doScroll, 150);
    } else {
      doScroll();
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 shadow-md" style={{ backgroundColor: '#e3628d' }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link className="text-xl font-bold text-white" to="/" onClick={() => setIsMobileMenuOpen(false)}>うのつのぶこ</Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            {navItems.map((item) => (
              item.href.startsWith('#') ? (
                <button
                  key={item.name}
                  className="text-white hover:text-gray-100 transition-colors duration-200 font-medium"
                  onClick={() => navigateToHash(item.href)}
                >
                  {item.name}
                </button>
              ) : (
                <Link
                  key={item.name}
                  className="text-white hover:text-gray-100 transition-colors duration-200 font-medium"
                  to={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              )
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? 'メニューを閉じる' : 'メニューを開く'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-navigation"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav id="mobile-navigation" aria-label="モバイルメニュー" className="md:hidden py-4 bg-white shadow-lg rounded mt-2">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                item.href.startsWith('#') ? (
                  <button
                    key={item.name}
                    className="text-gray-700 hover:text-gray-900 transition-colors duration-200 font-medium text-left px-4 py-2"
                    onClick={() => navigateToHash(item.href)}
                  >
                    {item.name}
                  </button>
                ) : (
                  <Link
                    key={item.name}
                    className="text-gray-700 hover:text-gray-900 transition-colors duration-200 font-medium text-left px-4 py-2"
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                )
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header; 